module.exports = __webpack_public_path__ + "_assets/img/setting-v2.55c5bf80.svg";